import api from "@/services/axios.js";
import {
  PreSignZipUploadRequest,
  PreSignZipUploadResponse,
} from "../../types.ts";

export const preSignZipUpload = async (data: PreSignZipUploadRequest) => {
  const { data: preSignZipUploadResponse } =
    await api.post<PreSignZipUploadResponse>(
      "/api/AdminVerification/presign-zip-upload",
      data,
    );
  if (
    !preSignZipUploadResponse ||
    !preSignZipUploadResponse.uploadUrl ||
    !preSignZipUploadResponse.zipKey
  ) {
    throw new Error("Failed to pre-sign zip upload");
  }
  return preSignZipUploadResponse;
};
